import { CometChat } from "@cometchat/chat-sdk-javascript";
import {
  CometChatUIKit,
  UIKitSettingsBuilder,
} from "@cometchat/chat-uikit-react";

const appId = process.env.REACT_APP_COMETCHAT_APP_ID;
const region = process.env.REACT_APP_COMETCHAT_REGION;
const authKey = process.env.REACT_APP_COMETCHAT_AUTH_KEY;

export const missingCometChatConfigMessage =
  "Set REACT_APP_COMETCHAT_APP_ID, REACT_APP_COMETCHAT_REGION, and REACT_APP_COMETCHAT_AUTH_KEY to enable chat.";

export const isCometChatConfigured = Boolean(appId && region && authKey);

let initializationPromise;

const buildUIKitSettings = () =>
  new UIKitSettingsBuilder()
    .setAppId(appId)
    .setRegion(region)
    .setAuthKey(authKey)
    .setAutoEstablishSocketConnection(true)
    .subscribePresenceForAllUsers()
    .build();

export const initializeCometChat = () => {
  if (!isCometChatConfigured) {
    return Promise.reject(new Error(missingCometChatConfigMessage));
  }

  if (!initializationPromise) {
    initializationPromise = CometChatUIKit.init(buildUIKitSettings()).catch(
      (error) => {
        initializationPromise = undefined;
        throw error;
      }
    );
  }

  return initializationPromise;
};

const sanitizeUid = (uid = "") => uid.trim();

export const getLoggedInCometChatUser = () => CometChatUIKit.getLoggedinUser();

export const logoutCometChatUser = () => CometChatUIKit.logout();

export const loginCometChatUser = async (uid) => {
  const trimmedUid = sanitizeUid(uid);

  if (!trimmedUid) {
    throw new Error("A CometChat user ID is required.");
  }

  await initializeCometChat();

  const existingUser = await CometChatUIKit.getLoggedinUser();

  if (
    existingUser &&
    (existingUser.uid === trimmedUid || existingUser.getUid?.() === trimmedUid)
  ) {
    return existingUser;
  }

  if (existingUser) {
    await CometChatUIKit.logout();
  }

  return CometChatUIKit.login(trimmedUid);
};

export const createCometChatUser = async ({ uid, name }) => {
  const trimmedUid = sanitizeUid(uid);

  if (!trimmedUid) {
    throw new Error("A CometChat user ID is required.");
  }

  await initializeCometChat();

  const user = new CometChat.User(trimmedUid);
  user.setName(sanitizeUid(name) || trimmedUid);

  return CometChatUIKit.createUser(user);
};
